import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import "./ReadyToStart.scss";
import { Icon, Button, Column } from "..";
import * as ReactDOM from "react-dom";
import Modal from "../Modal/Modal";
import useAppContext from "../../context/Context";
export const ReadyToStart = ({ color, bgColor, ...otherProps }) => {
  const { countries, activeCountry } = useAppContext();

  const intl = useIntl();
  const [openModal, setOpenModal] = useState(false);

  let colorIconDolar =0;
  if(bgColor =="#140F33"){
    colorIconDolar=1;
  }

  const changeModal = () => {
    setOpenModal(!openModal);
  };
  return (
    <Column
      customClass={"ready-to-start"}
      {...otherProps}
      style={{
        color: color,
        background: bgColor,
      }}
    >
      {openModal === true &&
        ReactDOM.createPortal(
          <Modal
            changeModal={changeModal}
            content={
              <iframe
                className="iframe"
                src={
                  activeCountry === "mx"
                    ? "https://share.hsforms.com/14Hl-W1oeQx-uUbcs4v0x5A5l986"
                    : "https://share.hsforms.com/1nESwD7ncTxK4ewZnR1u7yQ5l986"
                }
                frameborder="0"
              ></iframe>
            }
          ></Modal>,
          document.getElementById("portal")
        )}

      <div className="left">
        <h2 className="title" style={{ color: color }}>
          {intl.formatMessage({ id: "readyToStart.title" })}
        </h2>
        <div className="description" style={{ color: color }}>
          {intl.formatMessage({ id: "readyToStart.description" })}
        </div>
        <div className="buttons">
          <div>
            <a
              onClick={() => {
                window.location = "https://dashboard.etpay.com/sign-up";
              }}
            >
              <Button bgColor={"#72DBAA"} bgHoverColor="#140F33">
                <Icon name={"Icon_Pre"} className="fillable" />
                <span>
                  {intl.formatMessage({ id: "button.testFree.text" })}
                </span>
              </Button>
            </a>
          </div>
          <div>
            <a
              href={
                "tel:" + intl.formatMessage({ id: "banner.home.button2.url" })
              }
            >
              <Button bgColor={"#F2F2F2"} bgHoverColor="#140F33">
                <span>
                  {intl.formatMessage({ id: "banner.home.button2.text" }) +
                    intl.formatMessage({ id: "banner.home.button2.url" })}
                </span>
                <Icon name="icon-phone"></Icon>
              </Button>
            </a>
          </div>
        </div>
      </div>
      <div></div>

      <div className="right">
        <Icon className="sign" name="Dollar" color={colorIconDolar?"#E6E6E6":color}></Icon>
        <h2 className="title" style={{ color: color }}>
          {intl.formatMessage({ id: "readyToStart.center.title" })}
        </h2>
        <h3 className="description" style={{ color: color }}>
          {intl.formatMessage({ id: "readyToStart.center.description" })}
        </h3>

        <Link to={intl.formatMessage({ id: "readyToStart.center.link.url" })}>
          <div className="link" style={{ color: color }}>
            {intl.formatMessage({ id: "readyToStart.center.link" })}
            <Icon name="Icon_After" color={color}></Icon>
          </div>
        </Link>
      </div>
      <div className="right">

        {color === "white"? <img src="/icons/Timer-whiteNew.svg" width="39"  />: 
        <Icon
        className="sign"
        name={`Timer${color === "white" ? "-whiteNew" : ""}`}
        color={color}
        size={39}
      ></Icon>}
       
        
        <h2 className="title" style={{ color: color }}>
          {intl.formatMessage({ id: "readyToStart.right.title" })}
        </h2>
        <h3 className="description" style={{ color: color }}>
          {intl.formatMessage({ id: "readyToStart.right.description" })}
        </h3>

        <Link
          to={intl.formatMessage({ id: "easy_integration.home.button.url" })}
        >
          <div className="link" style={{ color: color }}>
            {intl.formatMessage({ id: "readyToStart.right.link" })}
            <Icon name="Icon_After" color={color}></Icon>
          </div>
        </Link>
      </div>
    </Column>
  );
};
